import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        width: "100%",
    },

    mainPage: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        flexDirection: "column",
        width: "99.5%",
        padding: "20px 72px",
    },

    snackbar_container: {
        left: "45%",
        top: "100px",
        position: "fixed",
        zIndex: 100,
    },

    title_container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        marginBottom: "32px",
        position: "relative",
    },

    recommended_container: {
        marginBottom: "32px",
        marginTop: "48px",
    },

    bottomTitle: {
        color: "#000",
        letterSpacing: 0,
        fontSize: "24px",
        marginBottom: "4px",
    },

    bottomSubText: {
        marginBottom: "12px",
    },

    recommendedProduct: {},

    buttons_container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        margin: "20px 0px",
    },

    mobile_buttons_container: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        width: "100%",
        marginTop: "20px",
        margin: "20px 0px",
    },

    title_container_mobile: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        flexDirection: "column-reverse",
        width: "100%",
        marginBottom: "24px",
    },
}));

export default useStyles;
